// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/********************************************************************************
 * Copyright (C) 2022 TypeFox and others.
 *
 * This program and the accompanying materials are made available under the
 * terms of the Eclipse Public License v. 2.0 which is available at
 * http://www.eclipse.org/legal/epl-2.0.
 *
 * This Source Code may also be made available under the following Secondary
 * Licenses when the conditions for such availability set forth in the Eclipse
 * Public License v. 2.0 are satisfied: GNU General Public License, version 2
 * with the GNU Classpath Exception which is available at
 * https://www.gnu.org/software/classpath/license.html.
 *
 * SPDX-License-Identifier: EPL-2.0 OR GPL-2.0-only WITH Classpath-exception-2.0
 ********************************************************************************/

/* Adapted from https://github.com/microsoft/vscode/blob/7d9b1c37f8e5ae3772782ba3b09d827eb3fdd833/src/vs/workbench/services/hover/browser/hoverService.ts */

:root {
  --theia-hover-max-width: 500px;
  --theia-hover-preview-width: 300px;
}

.theia-hover {
  font-family: var(--theia-ui-font-family);
  font-size: var(--theia-ui-font-size1);
  color: var(--theia-editorHoverWidget-foreground);
  background-color: var(--theia-editorHoverWidget-background);
  border: 1px solid var(--theia-editorHoverWidget-border);
  padding: var(--theia-ui-padding);
  max-width: var(--theia-hover-max-width);
}

.theia-hover .hover-row:not(:first-child):not(:empty) {
  border-top: 1px solid var(--theia-editorHoverWidgetInternalBorder);
}

.theia-hover hr {
  border-top: 1px solid var(--theia-editorHoverWidgetInternalBorder);
  border-bottom: 0px solid var(--theia-editorHoverWidgetInternalBorder);
  margin: var(--theia-ui-padding) calc(var(--theia-ui-padding) * -1);
}

.theia-hover a {
  color: var(--theia-textLink-foreground);
}

.theia-hover a:hover {
  color: var(--theia-textLink-active-foreground);
}

.theia-hover .hover-row .actions {
  background-color: var(--theia-editorHoverWidget-statusBarBackground);
}

.theia-hover code {
  background-color: var(--theia-textCodeBlock-background);
  font-family: var(--theia-code-font-family);
}

.theia-hover::before {
  content: "";
  position: absolute;
}

.theia-hover.top::before {
  left: var(--theia-hover-before-position);
  bottom: -5px;
  border-top: 5px solid var(--theia-editorHoverWidget-border);
  border-left: 5px solid transparent;
  border-right: 5px solid transparent;
}

.theia-hover.bottom::before {
  left: var(--theia-hover-before-position);
  top: -5px;
  border-bottom: 5px solid var(--theia-editorHoverWidget-border);
  border-left: 5px solid transparent;
  border-right: 5px solid transparent;
}

.theia-hover.left::before {
  top: var(--theia-hover-before-position);
  right: -5px;
  border-left: 5px solid var(--theia-editorHoverWidget-border);
  border-top: 5px solid transparent;
  border-bottom: 5px solid transparent;
}

.theia-hover.right::before {
  top: var(--theia-hover-before-position);
  left: -5px;
  border-right: 5px solid var(--theia-editorHoverWidget-border);
  border-top: 5px solid transparent;
  border-bottom: 5px solid transparent;
}

.theia-hover.extended-tab-preview {
  border-radius: 10px;
  width: var(--theia-hover-preview-width);
}
`, "",{"version":3,"sources":["webpack://./../../actions-runner/_work/arduino-ide/arduino-ide/node_modules/@theia/core/src/browser/style/hover-service.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;;;iFAciF;;AAEjF,2JAA2J;;AAE3J;EACE,8BAA8B;EAC9B,kCAAkC;AACpC;;AAEA;EACE,wCAAwC;EACxC,qCAAqC;EACrC,gDAAgD;EAChD,2DAA2D;EAC3D,uDAAuD;EACvD,gCAAgC;EAChC,uCAAuC;AACzC;;AAEA;EACE,kEAAkE;AACpE;;AAEA;EACE,kEAAkE;EAClE,qEAAqE;EACrE,kEAAkE;AACpE;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,8CAA8C;AAChD;;AAEA;EACE,oEAAoE;AACtE;;AAEA;EACE,uDAAuD;EACvD,0CAA0C;AAC5C;;AAEA;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,wCAAwC;EACxC,YAAY;EACZ,2DAA2D;EAC3D,kCAAkC;EAClC,mCAAmC;AACrC;;AAEA;EACE,wCAAwC;EACxC,SAAS;EACT,8DAA8D;EAC9D,kCAAkC;EAClC,mCAAmC;AACrC;;AAEA;EACE,uCAAuC;EACvC,WAAW;EACX,4DAA4D;EAC5D,iCAAiC;EACjC,oCAAoC;AACtC;;AAEA;EACE,uCAAuC;EACvC,UAAU;EACV,6DAA6D;EAC7D,iCAAiC;EACjC,oCAAoC;AACtC;;AAEA;EACE,mBAAmB;EACnB,uCAAuC;AACzC","sourcesContent":["/********************************************************************************\n * Copyright (C) 2022 TypeFox and others.\n *\n * This program and the accompanying materials are made available under the\n * terms of the Eclipse Public License v. 2.0 which is available at\n * http://www.eclipse.org/legal/epl-2.0.\n *\n * This Source Code may also be made available under the following Secondary\n * Licenses when the conditions for such availability set forth in the Eclipse\n * Public License v. 2.0 are satisfied: GNU General Public License, version 2\n * with the GNU Classpath Exception which is available at\n * https://www.gnu.org/software/classpath/license.html.\n *\n * SPDX-License-Identifier: EPL-2.0 OR GPL-2.0-only WITH Classpath-exception-2.0\n ********************************************************************************/\n\n/* Adapted from https://github.com/microsoft/vscode/blob/7d9b1c37f8e5ae3772782ba3b09d827eb3fdd833/src/vs/workbench/services/hover/browser/hoverService.ts */\n\n:root {\n  --theia-hover-max-width: 500px;\n  --theia-hover-preview-width: 300px;\n}\n\n.theia-hover {\n  font-family: var(--theia-ui-font-family);\n  font-size: var(--theia-ui-font-size1);\n  color: var(--theia-editorHoverWidget-foreground);\n  background-color: var(--theia-editorHoverWidget-background);\n  border: 1px solid var(--theia-editorHoverWidget-border);\n  padding: var(--theia-ui-padding);\n  max-width: var(--theia-hover-max-width);\n}\n\n.theia-hover .hover-row:not(:first-child):not(:empty) {\n  border-top: 1px solid var(--theia-editorHoverWidgetInternalBorder);\n}\n\n.theia-hover hr {\n  border-top: 1px solid var(--theia-editorHoverWidgetInternalBorder);\n  border-bottom: 0px solid var(--theia-editorHoverWidgetInternalBorder);\n  margin: var(--theia-ui-padding) calc(var(--theia-ui-padding) * -1);\n}\n\n.theia-hover a {\n  color: var(--theia-textLink-foreground);\n}\n\n.theia-hover a:hover {\n  color: var(--theia-textLink-active-foreground);\n}\n\n.theia-hover .hover-row .actions {\n  background-color: var(--theia-editorHoverWidget-statusBarBackground);\n}\n\n.theia-hover code {\n  background-color: var(--theia-textCodeBlock-background);\n  font-family: var(--theia-code-font-family);\n}\n\n.theia-hover::before {\n  content: \"\";\n  position: absolute;\n}\n\n.theia-hover.top::before {\n  left: var(--theia-hover-before-position);\n  bottom: -5px;\n  border-top: 5px solid var(--theia-editorHoverWidget-border);\n  border-left: 5px solid transparent;\n  border-right: 5px solid transparent;\n}\n\n.theia-hover.bottom::before {\n  left: var(--theia-hover-before-position);\n  top: -5px;\n  border-bottom: 5px solid var(--theia-editorHoverWidget-border);\n  border-left: 5px solid transparent;\n  border-right: 5px solid transparent;\n}\n\n.theia-hover.left::before {\n  top: var(--theia-hover-before-position);\n  right: -5px;\n  border-left: 5px solid var(--theia-editorHoverWidget-border);\n  border-top: 5px solid transparent;\n  border-bottom: 5px solid transparent;\n}\n\n.theia-hover.right::before {\n  top: var(--theia-hover-before-position);\n  left: -5px;\n  border-right: 5px solid var(--theia-editorHoverWidget-border);\n  border-top: 5px solid transparent;\n  border-bottom: 5px solid transparent;\n}\n\n.theia-hover.extended-tab-preview {\n  border-radius: 10px;\n  width: var(--theia-hover-preview-width);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
